export enum HeadlineMessageType {
  headline = 'headline',
  new = 'new-headline',
  delete = 'remove-headline',
  archive = 'archive-headline',
  unarchive = 'unarchive-headline',
  fetch = 'fetch-object',
  sort = 'list-sort-headline',
}
